import React from "react"

const ViewFeedItemMedia = ({ attachment, embeddedMedia, isFetching }) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Media
        </h3>
        <div className="widget-content visible">
            {embeddedMedia && <EmbeddedMedia {...embeddedMedia} />}
            {attachment && <EmbeddedAttachment {...attachment} />}
        </div>
    </div>
)

const EmbeddedMedia = ({ html, url, width, height, title }) => {
    if (html) {
        return (
            <div
                className="embedded-container"
                dangerouslySetInnerHTML={{ __html: html }}
            />
        )
    } else if (url) {
        return (
            <div className="embedded-container">
                <iframe title={title} src={url} width={width} height={height} />
            </div>
        )
    } else {
        return null
    }
}

const EmbeddedAttachment = ({ url, type, mimetype }) => {
    const sourceElement = <source src={url} type={mimetype} />
    const fallbackElement = (
        <p>
            Your browser doesn't support this format, here is the{" "}
            <a href={url}>download link</a>.
        </p>
    )
    if (type === "audio") {
        return (
            <audio controls>
                {sourceElement}
                {fallbackElement}
            </audio>
        )
    } else if (type === "video") {
        return (
            <video controls>
                {sourceElement}
                {fallbackElement}
            </video>
        )
    } else {
        return null
    }
}

export default ViewFeedItemMedia
